app.directive('selectSingleHeader', ['$filter', function($filter){
    return {
        restrict: 'EA',
        replace: true,
        transclude: true,
        scope: {
            'title': '@',
            'default': '@',
            'disable': '=',
            'removeTitle': '@',
            'data': '=',
            'classDropdown': '@',
            'disableSearch' : '@'
        },
        templateUrl: "application/templates/directives/selectSingleHeader.html",
        controller: function($scope){

            $scope.hideSpan = $scope.default ? true : false;

            $scope.default = $scope.default ? $scope.default : null;

            $scope.config = {
                setHeight : 40 * $scope.data.length
            };

            $scope.changeValue = function (value) {
                $scope.default = value;
                $scope.hideSpan = $scope.default ? true : false;
            };
        }
    }
}]);
